var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M23.714 26.25c0 .689-.577 1.25-1.285 1.25h-18c-.709 0-1.286-.561-1.286-1.25V25c0-3.924 2.337-7.325 5.73-8.961 1.278.914 2.85 1.461 4.556 1.461 1.705 0 3.277-.547 4.556-1.461 3.392 1.636 5.73 5.037 5.73 8.961v1.25zM8.286 7.5c0-2.757 2.306-5 5.143-5 2.836 0 5.142 2.243 5.142 5V10c0 2.757-2.306 5-5.142 5-2.837 0-5.143-2.243-5.143-5V7.5zm11.543 6.682c.83-1.196 1.314-2.634 1.314-4.182V7.5c0-4.136-3.46-7.5-7.714-7.5-4.255 0-7.715 3.364-7.715 7.5V10c0 1.548.485 2.986 1.314 4.182C3.176 16.342.571 20.375.571 25v1.25C.571 28.317 2.302 30 4.43 30h18c2.126 0 3.857-1.683 3.857-3.75V25c0-4.625-2.605-8.658-6.457-10.818z","opacity":".8"}));
}

Profile.defaultProps = {"width":"27","height":"30","viewBox":"0 0 27 30"};

module.exports = Profile;

Profile.default = Profile;
